import React from 'react'
import Icon from './Icon'

interface ListRowItem {
  title: string
  onClick: React.ReactEventHandler
  active?: boolean
  icon?: string
  iconHeight?: number
}

export const ListRowItem = ({ title, onClick, active = false, icon, iconHeight }: ListRowItem) => {
  return (
    <div className='flex cursor-pointer py-2 border-b-[1px] items-center text-sm' onClick={onClick}>
      <div className='flex flex-grow items-center gap-2'>
        {icon && (
          <div className='flex'>
            <Icon iconSrc={icon} height={iconHeight || 30} alt={title} lazyLoad={false} />
          </div>
        )}
        <div className='flex'>{title}</div>
      </div>
      <div className='flex'>
        {active ? (
          <Icon width={23} iconSrc='/icons/ic-check-mark.svg' alt={title} />
        ) : (
          <Icon width={8} iconSrc='/icons/ic-chevron-right.svg' alt={title} />
        )}
      </div>
    </div>
  )
}
